import { Grid } from '@mui/material';
import { IraceEvent } from '..';
import classes from './styles';

const IraceEventList = ({ events }) => {
  // console.log('irace event list');
  return (
    <Grid container style={classes.iraceEventListContainer}>
      {events.map((ev, idx) => (
        <IraceEvent event={ev} i={idx} />
      ))}
    </Grid>
  );
};

export default IraceEventList;
